export const AdoptionModelData = function () {
  return {
    adoptionList: [],
    queryParams: '',
    mappedAdoptionList: [],
    adoptionLevel: '',
    adoptionLevelFor: '',
    adoptionName: '',
    exportAdoptionList: []
  }
}
